import { Grid } from '@elliemae/ds-grid';
import styled from 'styled-components';

export default styled.div`
  width: 100%;
  > div {
    > div {
      display: flex;
      justify-content: flex-end;
    }
  }
`;

interface StyledBestExRowSelectedProps {
  gridRow?: boolean;
  targetRow?: boolean;
  showMIColumn?: boolean;
}

export const StyledBestExRowSelected = styled.div<StyledBestExRowSelectedProps>`
  ${({ gridRow }) => (gridRow ? 'height: 32px;' : 'height: 36px;')};
  max-height: 36px;
  width: calc(100% + 1.23076rem);
  margin-left: -0.61538rem;
  margin-right: -0.61538rem;
  padding-left: ${({ showMIColumn }) => (showMIColumn ? '0' : '0.61538rem')};
  padding-right: ${({ showMIColumn }) => (showMIColumn ? '0' : '0.61538rem')};
  display: flex;
  align-items: center;
  ${({ targetRow }) => (targetRow ? 'background: #EBF6FF;' : '')}
`;

// Sat in the program cell text flow as anchors, so the typography the global
// a rule gave them is restated here for a button.
export const StyledBestExLockLink = styled.button.attrs({ type: 'button' })`
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-weight: 400;
  line-height: 1.5;
  vertical-align: baseline;
  text-decoration: none;
  color: #1e79c2;
  cursor: pointer;

  &:disabled {
    color: black;
    cursor: default;
  }
`;

export const StyledBestExProgramLinks = styled.button.attrs({
  type: 'button',
})<{ isBest?: boolean }>`
  padding: 0;
  border: none;
  background: none;
  /* before any weight below it: the font shorthand resets font-weight */
  font: inherit;
  /* what the global p rule gave this as a paragraph */
  font-size: 1rem;
  line-height: normal;
  font-weight: 400;
  ${({ isBest }) => (isBest ? 'font-weight: bold;' : '')}
  color: #3989ca;
  cursor: pointer;
  text-decoration: underline;
`;

export const StyledTableTitle = styled(Grid)`
  background-color: ${({ theme }) => theme.colors.brand[200]};
  border-top: 2px solid ${({ theme }) => theme.colors.brand[400]};
  align-items: center;
  font-weight: bold;
`;

export const StyledAprCell = styled.span`
  min-width: 0;
  width: 100%;
  text-align: right;
  padding-right: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledProductNotesList = styled.div`
  ul {
    padding-right: 20px;
  }
`;
